<script>
  import axios from "axios";
  import { t } from "../../../../core";

  import { userInfo } from "../user/user-store";

  function stopImpersonation() {
    axios
      .post("/api/SuperCustomer/stopImpersonation")
      .then(() => (window.location.href = "/"));
  }
</script>

{#if $userInfo !== null && $userInfo.isImpersonationMode}
  <div class="g-centered stop-impersonation">
    <button on:click={stopImpersonation} class="btn">
      {t("Impersonation.Action.Stop")}
    </button>
  </div>
{/if}

<style lang="scss">
  .stop-impersonation {
    position: fixed;
    z-index: 10;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    justify-content: flex-end;
    pointer-events: none;

    .btn {
      pointer-events: all;
    }

    @include md {
      top: 0;
      bottom: initial;
    }
  }
</style>
